import { shareListModalStyles as styles } from "@insite/content-library/Components/ShareListModal";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,

    gap: 10,
};

styles.modal = {
    ...styles.modal,

    cssOverrides: {
        modalTitle: css`
            ${styles.modal?.cssOverrides?.modalTitle}

            padding: 7px 10px;

            ${mediaQueriesBP.minMD} {
                padding: 7px 10px 7px 22px;
            }
        `,

        modalContent: css`
            ${styles.modal?.cssOverrides?.modalContent}

            padding: 10px;

            ${mediaQueriesBP.minMD} {
                padding: 20px 20px 20px 22px;
            }
        `,
    },
};

styles.shareByBillingRadio = {
    ...styles.shareByBillingRadio,
    css: css`
        input {
            margin-left: 0;

            ${mediaQueriesBP.minSM} {
                margin-left: 20px;
            }
        }
    `,
};

styles.recipientEmailTooltip = {
    ...styles.recipientEmailTooltip,
    cssOverrides: {
        tooltipContainer: css`
            margin-left: -150px;
            &::after {
                left: 150px;
            }
        `,
    },
};

styles.yourNameTextField = {
    ...styles.yourNameTextField,
    labelProps: {
        css: css`
            ${styles.yourNameTextField?.labelProps?.css}

            ${mediaQueriesBP.minMD} {
                min-height: 26px;
            }
        `,
    },
};

styles.recipientEmailAddressTextField = {
    ...styles.recipientEmailAddressTextField,
    labelProps: {
        css: css`
            ${styles.recipientEmailAddressTextField?.labelProps?.css}

            ${mediaQueriesBP.minMD} {
                min-height: 26px;
            }
        `,
    },
};
